<template>
  <div>
    <Breadcrumbs main="Watches" title="Раздел Watch"/>
    <div class="container-fluid">
      <b-tabs content-class="mt-3" fill lazy>
        <b-tab title="Трансляции" active>
          <WatchStreams/>
        </b-tab>
        <b-tab title="Предикты">
          <WatchPredicts/>
        </b-tab>
        <b-tab title="Голосования">
          <WatchPolls/>
        </b-tab>
        <b-tab title="Боление">
          <WatchFanSupport/>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import WatchStreams from '@/components/Watch/WatchStreams';
import WatchPredicts from '@/components/Watch/WatchPredicts';
import WatchPolls from '@/components/Watch/WatchPolls';
import WatchFanSupport from '@/components/Watch/WatchFanSupport';

export default {
  name: "ListWatches",
  components: {
    WatchStreams,
    WatchPredicts,
    WatchPolls,
    WatchFanSupport
  }
}
</script>

<style scoped>
.nav-tabs {
  border-bottom: 1px solid #dee2e6;
}

.nav-tabs .nav-link {
  margin-bottom: -1px;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
</style>